<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app'
	}
</script>

<style>
	@import url("common/font.css");

	* {
		outline: none;
	}

	a {
		text-decoration: none;
	}

	html,
	body {
		width: 100%;
		height: 100%;
		padding: 0px;
		margin: 0px;
		box-sizing: border-box;
		font-family: "Monospaced Number", Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
	}

	#app {
		color: #2c3e50;
		width: 100%;
		height: 100%;
	}

	#nprogress .bar {
		background: #00aeff !important;
	}

	.link {
		color: #409EFF;
		font-weight: bold;
		cursor: pointer;
		margin-right: 0.125rem;
	}

	.link.add {
		color: #67C23A;
	}

	.link.del {
		color: #F56C6C;
	}

	.grid-content {
		position: relative;
		margin-top: 1.25rem;
		padding: 1.25rem 1.5rem;
		background-color: white;
	}

	.grid-content:nth-child(1) {
		margin-top: 0;
	}

	.grid-content .grid-content-title {
		display: flex;
		align-items: center;
	}

	.grid-content .grid-content-title .name {
		flex: 1;
		font-size: 0.9375rem;
		font-weight: bold;
		color: rgba(0, 0, 0, .75);
	}

	.grid-content .grid-content-search,
	.grid-content .grid-content-operate,
	.grid-content .grid-content-content {
		margin-top: 1.25rem;
	}

	.grid-content .grid-content-search .line {
		margin-top: 1.25rem;
	}

	.grid-content .grid-content-search .line .box {
		display: flex;
		align-items: center;
	}

	.grid-content .grid-content-search .line .box .label {
		font-size: 0.8125rem;
	}

	.grid-content .grid-content-search .line .box .input {
		flex: 1;
	}

	.grid-content .grid-content-search .line .box .input .input-with-select .el-select {
		width: 8.125rem;
	}

	.grid-content .grid-content-total {
		position: absolute;
		display: flex;
		align-items: center;
		top: 1.25rem;
		right: 1.5rem;
		padding: 0 0.8rem;
		min-width: 12.5rem;
		height: 3.2rem;
		font-size: 0.875rem;
		border-radius: 0.25rem;
		background-color: #eff8fe;
		border: 1px #ebeef5 solid;
	}

	.grid-content .grid-content-total .l {
		margin-right: 1.5rem;
	}

	.grid-content .grid-content-total .wt {
		margin-left: 1rem;
		font-size: 1.125rem;
	}

	.grid-content .grid-content-list {
		margin-top: 2rem;
	}

	/* 	

	.grid-content .title {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	.grid-content .title::before {
		position: absolute;
		top: 50%;
		left: 0;
		content: "";
		width: 0.25rem;
		height: 1.25rem;
		margin-top: -0.625rem;
		background-color: #00AEFF;
	}

	.grid-content .title .right {
		position: absolute;
		top: 0;
		right: 1.5rem;
		height: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.grid-content .title .el-tabs__header {
		margin: 0;
	}

	.grid-content .title .el-tabs__nav-wrap {
		padding: 0 1.5rem;
	}

	.grid-content .title .el-tabs__item {
		height: 3.125rem;
		line-height: 3.125rem;
	}

	.grid-content .title .el-tabs__nav-wrap::after {
		background-color: #F0F0F0;
	}

	.grid-content .title .right .el-icon-sort {
		transform: rotate(90deg);
	} */

	/* 	.grid-content.cost .list,
	.grid-content.order .list,
	.grid-content.comment .list,
	.grid-content.paylog .list,
	.grid-content.driver .list,
	.grid-content.user .list,
	.grid-content.region .list{
		position: relative;
		min-height: 20rem;
	}

	.grid-content.cost .list .loading,
	.grid-content.order .list .loading,
	.grid-content.comment .list .loading,
	.grid-content.paylog .list .loading,
	.grid-content.driver .list .loading,
	.grid-content.user .list .loading,
	.grid-content.region .list .loading {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	} */

	/* .handle {
		display: flex;
		align-items: center;
		flex-direction: row;
		padding: 0 1.5rem;
		height: 4.375rem;
	}

	.handle .el-form-item__error {
		padding-top: 0;
	}

	.handle .labeling {
		font-size: 0.75rem;
	}

	.handle .labeling div {
		display: inline-block;
	}

	.handle .labeling .tt {
		font-size: 0.875rem;
	}

	.handle .labeling .lie {
		margin-right: 0.9375rem;
	}

	.handle .labeling .icon {
		display: inline-block;
		width: 0.9375rem;
		height: 0.9375rem;
		background-color: #00AEFF;
		margin-right: 0.25rem;
		vertical-align: text-bottom;
	}

	.handle .labeling .k {
		color: black;
	}

	.handle .labeling .k .icon {
		background-color: black;
	}

	.handle .labeling .a {
		color: #FF0000;
	}

	.handle .labeling .a .icon {
		background-color: #FF0000;
	}

	.handle .labeling .b {
		color: #07C160;
	}

	.handle .labeling .b .icon {
		background-color: #07C160;
	}

	.handle .labeling .c {
		color: #FF8E43;
	}

	.handle .labeling .c .icon {
		background-color: #FF8E43;
	}

	.handle .labeling .d {
		color: #00AEFF;
	}

	.handle .motion {
		position: relative;
		margin-left: 1.875rem;
		padding-left: 1.875rem;
	}

	.handle .motion::before {
		position: absolute;
		content: "";
		top: 50%;
		left: 0;
		width: 1px;
		height: 1.4rem;
		margin-top: -0.7rem;
		background-color: #D9D9D9;
	}

	.handle .el-radio-group {
		position: relative;
	}

	.handle .el-radio-group .dot {
		position: absolute;
		top: 0.1rem;
		right: 0.1rem;
		color: white;
		font-size: 0.75rem;
		min-width: 0.625rem;
		padding: 0 0.1875rem;
		line-height: 1rem;
		background-color: red;
		border-radius: 50%;
	} */

	.el-drawer__header span {
		color: black;
	}

	.el-dialog .el-table th.is-leaf {
		color: #8192a0;
		background-color: #f0f8ff
	}

	.el-dialog .el-dialog__body {
		padding: 0.625rem 1.25rem;
	}

/* 	.drawer-form {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.drawer-form .content {
		flex: 1;
		padding: 0 2.5rem;
		overflow-x: hidden !important;
		overflow-y: auto !important;
	}

	.drawer-form .content::-webkit-scrollbar {
		width: 0.375rem;
		height: 0.375rem;
	}

	.drawer-form .content::-webkit-scrollbar-thumb {
		border-radius: 0.625rem;
		background-color: #8c8c8c;
		-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);
	}

	.drawer-form .content .form .el-form-item__content {
		display: flex;
		align-items: center;
	}

	.drawer-form .content .form .tips {
		position: relative;
		font-size: 0.75rem;
		padding: 0 0.625rem;
		color: #5A606B;
		background: #F6F6F6;
		margin-left: 1.25rem;
	}

	.drawer-form .content .form .tips::before {
		position: absolute;
		content: '';
		width: 10px;
		height: 10px;
		font-size: 0;
		transform: rotate(45deg);
		left: -6px;
		top: 50%;
		margin-top: -6px;
		background: #F6F6F6;
		border-width: 0 0 1px 1px;
	}

	.drawer-form .footer {
		padding: 0.8rem 2.5rem;
	} */


	.drawer {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
	
	.drawer .content {
		flex: 1;
		padding: 0 2.5rem;
		overflow-x: hidden !important;
		overflow-y: auto !important;
	}
	
	.drawer .content::-webkit-scrollbar {
		width: 0.375rem;
		height: 0.375rem;
	}
	
	.drawer .content::-webkit-scrollbar-thumb {
		border-radius: 0.625rem;
		background-color: #8c8c8c;
		-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);
	}
	
	.drawer .drawer-footer {
		display: flex;
		padding: 2rem 2.5rem;
	}
	
	.drawer .drawer-footer button {
		flex: 1;
	}
	
	.drawer .content .form .el-form-item__content {
		display: flex;
		align-items: center;
	}
	
	.drawer .content .form .tips {
		position: relative;
		font-size: 0.75rem;
		padding: 0 0.625rem;
		color: #5A606B;
		background: #F6F6F6;
		margin-left: 1.25rem;
	}
	
	.drawer .content .form .tips::before {
		position: absolute;
		content: '';
		width: 10px;
		height: 10px;
		font-size: 0;
		transform: rotate(45deg);
		left: -6px;
		top: 50%;
		margin-top: -6px;
		background: #F6F6F6;
		border-width: 0 0 1px 1px;
	}
	
	.drawer.driver .avatar {
		width: 6.25rem;
		height: 6.25rem;
		border: 1px dashed #d9d9d9;
		border-radius: 0.375rem;
		position: relative;
		overflow: hidden;
	}
	
	.drawer.driver .avatar.u {
		cursor: pointer;
	}
	
	.drawer.driver .avatar.u:hover {
		border-color: #409EFF;
	}
	
	.drawer.driver .avatar.u .avatar-uploader-icon {
		position: absolute;
		top: 0;
		left: 0;
		font-size: 1.75rem;
		color: #8c939d;
		width: 6.25rem;
		height: 6.25rem;
		line-height: 6.25rem;
		text-align: center;
	}
	
	.drawer.driver .avatar.y .close {
		position: absolute;
		top: 0;
		right: 0;
		color: red;
		font-size: 1.25rem;
		cursor: pointer;
	}
	
	/* 	.drawer-form .content .form .tips {
		display: inline-block;
	} */

	/* 	.drawer {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.drawer.project .amount {
		font-family: WechatSans;
		font-size: 3.4375rem;
		text-align: center;
	}

	.drawer.project .el-divider__text {
		color: #999;
		font-size: 0.75rem;
	}

	.drawer.project .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 100%;
	}

	.drawer.project .el-form-item>>>label {
		width: 60%;
		color: #99a9bf;
	}

	.drawer.project .el-form-item>>>.el-form-item__content {
		width: 40%;
		text-align: right;
	}

	.drawer-footer {
		display: flex;
	}

	.drawer-footer button {
		flex: 1;
	}

	.drawer.driver {
		width: 100%;
		height: 100%;
		padding: 0 2.5rem 2.5rem;
		box-sizing: border-box;
	}

	.drawer.driver .avatar {
		width: 6.25rem;
		height: 6.25rem;
		border: 1px dashed #d9d9d9;
		border-radius: 0.375rem;
		position: relative;
		overflow: hidden;
	}

	.drawer.driver .avatar.u {
		cursor: pointer;
	}

	.drawer.driver .avatar.u:hover {
		border-color: #409EFF;
	}

	.drawer.driver .avatar.u .avatar-uploader-icon {
		position: absolute;
		top: 0;
		left: 0;
		font-size: 1.75rem;
		color: #8c939d;
		width: 6.25rem;
		height: 6.25rem;
		line-height: 6.25rem;
		text-align: center;
	}

	.drawer.driver .avatar.y .close {
		position: absolute;
		top: 0;
		right: 0;
		color: red;
		font-size: 1.25rem;
		cursor: pointer;
	}

	.drawer>>>.el-input-group__append {
		cursor: pointer;
	} */

	/* 	.search {
		display: flex;
		align-items: center;
	}

	.search .search-form-inline .el-form-item {
		margin-bottom: 0;
	}

	.search .search-form-inline .el-form-item:last-child,
	.edit-amount .edit-form-inline .el-form-item:last-child {
		margin-right: 0;
	} */

	.feedback {
		position: absolute;
		display: flex;
		align-items: center;
		top: 0;
		right: 0;
	}

	/**
	 * el-radio
	 */
	.el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
		-webkit-box-shadow: none !important;
		box-shadow: none !important;
	}

	/**
	 * 表格
	 */
	.el-table {
		border-radius: 0.25rem;
	}

	.el-table th.is-leaf {
		color: #8192a0;
		background-color: #f0f8ff;
	}

	.el-table .el-table__footer-wrapper .cell {
		font-weight: bold;
	}

	/**
	 * 自定义表格
	 */
	.common-table table {
		width: 100%;
		border-collapse: collapse;
		border-spacing: 0;
	}

	.common-table table tr {
		transition: all .3s;
		-webkit-transition: all .3s;
	}

	.common-table table td {
		border: 1px #f1f1f1 solid;
	}

	.common-table table.header tr {
		color: #8192a0;
		font-size: 0.875rem;
		background-color: #eff8fe;
		border: 1px #ebeef5 solid;
	}

	.common-table table.header tr th {
		padding: 0.5rem 0;
	}

	.common-table table.header tr th:nth-child(2) {
		text-align: left;
		padding-left: 0.625rem;
	}

	.common-table table.body .separation-row td {
		height: 0.625rem;
		border: 0;
	}


/* 	.common-table table.body .header-row .item {
		display: flex;
		padding: 0.3rem 0.625rem;
	}

	.common-table table.body .header-row .left {
		flex: 1;
		display: flex;
	}

	.common-table table.body .header-row .left div:nth-child(1) {
		width: 16.5rem;
	}

	.common-table table.body .header-row .left div:nth-child(2) {
		width: 7.5rem;
	}

	.common-table table.body .header-row .right .del {
		cursor: pointer;
	}

	.common-table table.body .content-row .user {
		display: flex;
		align-items: center;
		padding: 10px;
		position: relative;
	}

	.common-table table.body .content-row .user .avatar {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 0.375rem;
	}

	.common-table table.body .content-row .user .info {
		margin-left: 0.3125rem;
	}

	.common-table table.body .content-row .user .info .name {
		font-size: 0.875rem;
		font-weight: bold;
		color: #576b95
	}

	.common-table table.body .content-row .user .info .lv {
		line-height: 1rem;
	}

	.common-table table.body .content-row .user .info .lv img {
		width: 2rem;
	}

	.common-table table.body .content-row .user .discount {
		position: absolute;
		top: -0.5rem;
		left: -0.625rem;
		color: white;
		font-size: 0.75rem;
		width: 2.5rem;
		height: 1.9375rem;
		line-height: 1.6rem;
		text-align: center;
		background-image: url(assets/corner_marker.png);
		background-size: 100% 100%;
		transform: scale(.7);
	}

	.common-table table.body .content-row .address {
		display: flex;
		justify-content: center;
	}

	.common-table table.body .content-row .address .start,
	.common-table table.body .content-row .address .end {
		width: 45%;
		color: #606266;
		font-size: .875rem;
		text-align: center;
		font-weight: bold;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.common-table table.body .content-row .address .end i {
		color: #2c3e50;
		font-weight: bold;
	}

	.common-table table.body .content-row .address .arrow {
		width: 10%;
		color: #999;
		font-size: 1.2rem;
		text-align: center;
	}

	.common-table table.body .content-row .cost .amount {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.common-table table.body .content-row .cost .amount span {
		font-family: WechatSans;
		font-size: 1.1rem;
	}

	.common-table table.body .content-row .cost .amount i {
		cursor: pointer;
		font-weight: bold;
		font-size: 0.85rem;
		margin-left: 0.3rem;
	}

	.common-table table.body .content-row .cost .mileage {
		font-size: 0.75rem;
		color: #666;
		text-align: center;
	}

	.common-table table.body .content-row .driver {
		font-size: 0.75rem;
		text-align: center;
	}

	.common-table table.body .content-row .driver .name {
		color: #333;
		font-size: 0.8125rem;
		font-weight: bold;
	}

	.common-table table.body .content-row .driver .name i {
		color: #999999;
		margin-left: 0.3125rem;
	}

	.common-table table.body .content-row .driver .name i.look {
		color: #67c23a;
	}

	.common-table table.body .content-row .driver .phone {
		color: #666;
	}

	.common-table table.body .content-row .status {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.75rem;
	}

	.common-table table.body .content-row .status .js {
		transform: scale(.8);
	}

	.common-table table.body .content-row .operate {
		display: flex;
		justify-content: center;
	} */

	/* div表格 */
	/* .page-table {
		display: table;
		width: 100%;
		border-collapse: collapse;
	}
	
	.page-table .el-loading-mask {
		top: -1px;
		left: -1px;
	}

	.page-table .page-table-row {
		display: table-row;
	}

	.page-table .page-table-row.thead-row {
		color: #8192a0;
		font-size: 0.875rem;
		font-weight: bold;
		background-color: #eff8fe;
		border: 1px #ebeef5 solid;
	}

	.page-table .page-table-row.thead-row .item-content {
		display: table-cell;
		vertical-align: middle;
		padding: 0.375rem 0.75rem;
	}

	.page-table .page-table-row.thead-row .item-content.center {
		text-align: center;
	}

	.page-table.currency .page-table-row.body-row:nth-child(even) {
		height: 15px;
	}

	.page-table.currency .page-table-row.body-row:nth-child(odd) {
		border: 1px #eee solid;
	}

	.page-table.currency .page-table-row.body-row:nth-child(odd) .item-content {
		border-left: 1px #eee solid;
	}

	.page-table.order .page-table-row.body-row {
		border: 1px #eee solid;
	}

	.page-table.order .page-table-row.body-row .item-content {
		position: relative;
		line-height: 1.375rem;
		border-left: 1px #eee solid;
	}

	.page-table.order .page-table-row.body-row:nth-child(3n-1) {
		height: 15px;
		border: 0;
	}

	.page-table .page-table-row.body-row .item-content {
		display: table-cell;
		vertical-align: middle;
		padding: 0.75rem;
		box-sizing: border-box;
	} */

	.page {
		text-align: right;
		margin-top: 3.125rem;
		margin-bottom: 1.5625rem;
	}

	.page .el-pagination {
		padding: 0.125rem 0;
	}

	.page .el-pagination>>>.btn-next {
		margin-right: 0;
	}

	.fain {
		animation: fain-anim 1.5s ease;
	}

	@keyframes fain-anim {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}
</style>
